
const PIXEL_ID = "4622525324645553";
const PIXEL_SOURCE = "https://connect.facebook.net/en_US/fbevents.js";

type PixelCommand = "init" | "track";
type PixelFunction = ((command: PixelCommand, event: string) => void) & {
  callMethod?: (command: PixelCommand, event: string) => void;
  queue?: Array<[PixelCommand, string]>;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}

let initialized = false;

function isPreviewEnvironment(): boolean {
  const hostname = window.location.hostname;
  const isEmbeddedPreview = window.self !== window.top;
  return (
    isEmbeddedPreview ||
    hostname.includes("magicpatterns") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  );
}

function createPixelQueue(): PixelFunction {
  const pixel = ((command: PixelCommand, event: string) => {
    if (pixel.callMethod) {
      pixel.callMethod(command, event);
      return;
    }
    pixel.queue?.push([command, event]);
  }) as PixelFunction;

  pixel.queue = [];
  pixel.loaded = true;
  pixel.version = "2.0";
  return pixel;
}

/**
 * Loads Meta Pixel only on a published site. Preview environments frequently block
 * third-party trackers; keeping the landing independent of that external script
 * prevents a tracker failure from interrupting page rendering.
 */
export function initMetaPixel(): void {
  if (initialized || typeof window === "undefined" || isPreviewEnvironment()) return;
  initialized = true;

  const pixel = window.fbq ?? createPixelQueue();
  window.fbq = pixel;
  window._fbq = pixel;

  pixel("init", PIXEL_ID);
  pixel("track", "PageView");

  const script = document.createElement("script");
  script.async = true;
  script.src = PIXEL_SOURCE;
  script.onerror = () => {
    // Tracking is optional for rendering. The queued events remain harmless if a
    // privacy extension or content policy blocks Meta's script.
    script.remove();
  };
  document.head.appendChild(script);
}

/** Tracks an InitiateCheckout event without making checkout navigation depend on tracking. */
export function trackCheckout(): void {
  window.fbq?.("track", "InitiateCheckout");
}

